"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "calice-al-cornoviglio": {
    "4d98784f": [{
      "hkey": "1cd51696",
      "slug": "calice-al-cornoviglio",
      "name": "Calice al Cornoviglio",
      "primary": true,
      "skipSearch": false
    }],
    "campi": [{
      "hkey": "1cd51696",
      "slug": "calice-al-cornoviglio",
      "name": "Calice al Cornoviglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6c043ba5": [{
      "hkey": "2964b939",
      "slug": "madrignano",
      "name": "Madrignano",
      "primary": true,
      "skipSearch": false
    }],
    "castello-di-madrignano": [{
      "hkey": "2964b939",
      "slug": "madrignano",
      "name": "Madrignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6947d229": [{
      "hkey": "1cd51696",
      "slug": "calice-al-cornoviglio",
      "name": "Calice al Cornoviglio",
      "primary": true,
      "skipSearch": false
    }],
    "provvedasco": [{
      "hkey": "1cd51696",
      "slug": "calice-al-cornoviglio",
      "name": "Calice al Cornoviglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8623c0c6": [{
      "hkey": "1cd51696",
      "slug": "calice-al-cornoviglio",
      "name": "Calice al Cornoviglio",
      "primary": true,
      "skipSearch": false
    }],
    "terruggiara-filettino": [{
      "hkey": "1cd51696",
      "slug": "calice-al-cornoviglio",
      "name": "Calice al Cornoviglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7a7e55d0": [{
      "hkey": "d3c6ccfb",
      "slug": "borseda",
      "name": "Borseda",
      "primary": true,
      "skipSearch": false
    }],
    "valle-del-torrente-usurana-borseda": [{
      "hkey": "d3c6ccfb",
      "slug": "borseda",
      "name": "Borseda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;